import { render, staticRenderFns } from "./CancellationRequest.vue?vue&type=template&id=16f3e86b&"
import script from "./CancellationRequest.vue?vue&type=script&lang=js&"
export * from "./CancellationRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports